<ng-container  *ngIf="! error">
<ng-container *ngFor="let control of formArray.controls">
  <form [formGroup]="control">
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
      <h3>{{control.value.economic_class}}</h3>

      <div>
        <h4 class="column-title">Individual</h4>
        <div fxLayout="row" fxLayoutGap="8px">
          <mat-form-field appearance="outline">
            <mat-label i18n>% Residential</mat-label>
            <input type="number" matInput formControlName="individual_res_rate">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label i18n>% Non residential</mat-label>
            <input type="number" matInput formControlName="individual_nres_rate">
          </mat-form-field>
        </div>
      </div>

      <div>
        <h4 class="column-title">Coletive</h4>
        <div fxLayout="row" fxLayoutGap="8px">
          <mat-form-field appearance="outline">
            <mat-label i18n>% Residential</mat-label>
            <input type="number" matInput formControlName="collective_res_rate">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label i18n>% Non residential</mat-label>
            <input type="number" matInput formControlName="collective_nres_rate">
          </mat-form-field>
        </div>
      </div>

    </div>
  </form>
</ng-container>
<mat-action-row>
  <button mat-button matDialogClose i18n>CLOSE</button>
  <button mat-raised-button (click)="save()" [disabled]="formArray.invalid || isSending" i18n>CHECK AREAS</button>
</mat-action-row>
</ng-container>
<h2 *ngIf="error" >Errors while validating the areas</h2>
<app-card-error *ngIf="error" [error]="error" (closed)="close()"></app-card-error>
